import * as React from 'react';
import { useMediaQuery, makeStyles, Typography } from '@material-ui/core';
import themePrimary from '../../styles/themePrimary';
import OkCancelButtons, { OkCancelButtonsProps } from '../common/Buttons/OkCancelButtons';
import { CheckTotal } from '../../models/payment/CheckTotal';
import { Tip } from '../../models/payment/Tip';
import { String_PayCheck_ServiceChargePopup, String_Split_TotalLabel, String_System_Cancel, String_System_CancelButton, String_System_View, String_Tip_ManualTipButton, String_Tip_ManualTipInstruction, String_Tip_SelectAdditionalTipInstruction, String_Tip_SelectTipInstruction } from '../../utilities/StringHelper';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { GetCurrencyCode } from '../../utilities/CurrencyHelper'
import ServiceChargeDialog, { ServiceChargeDialogProps } from './ServiceChargeDialog';
import { ElementDimensions } from '../../styles/ElementDimensions';
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';
import TipButton, {TipButtonProps} from './TipButton';
import CurrencyInput from 'react-currency-input-field';
import MiniButton, { MiniButtonProps } from '../common/Buttons/MiniButton';
import { CheckSummary } from '../../models/common/CheckSummary';
import ViewCheckDialog, { ViewCheckDialogProps } from '../common/ViewCheckDialog';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';
import CustomTipButton, { CustomTipButtonProps } from './CustomTipButton';
const useStyles = makeStyles({
    manualTipCancelButton: {
        marginTop:'auto',
        marginBottom:'auto',
        height:'50px',
        marginLeft: '10px',
    },
    manualTipGrid: {
        marginLeft:'auto',
        marginRight:'auto',
        display: 'grid',
        gridTemplateColumns: '20% 50% 30%',
        width: '90%',
    },
    manualTipContainer: {
        display: 'flex',
    },
    headerContainer: {
        backgroundColor: themePrimary.palette.grey[200],
        padding: ElementDimensions.padding10 + 'px ',
        margin: ElementDimensions.margin10 + 'px',
        borderRadius: '6px',
        display: 'flex',
    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: 'calc(70vw - 20px) calc(30vw - 20px)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    headerGridLandscape: {
        display: 'grid',
        gridTemplateColumns: 'calc(30vw - 10px) calc(70vw - 10px)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    okCancelButtonsContainer: {
        marginTop: '8px',
    },
    tipContainer: {
        display: 'flex',
        textAlign: 'center',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
        borderRadius: '6px',
    },
    tipOkCancelButtonsContainer: {
        width: '100%',
    },
    tipGrid: {
        gridTemplateColumns: '30% 30% 30%',
        width: '97%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: ElementDimensions.margin10 + 'px',
    },
    tipGridContainer: {
        textAlign: 'center',
        display: 'flex',
    },
    tipGridLandscape: {
        display: 'grid',
        gridTemplateColumns: '95px calc((100vw *.7) - 210px) 95px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    tipInnerContainer: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
    },
    tipInput: {
        height: '50px',
        fontSize: '1.8em',
        borderRadius: '4px',
        marginBottom: ElementDimensions.margin10 + 'px',
        borderColor:  themePrimary.palette.secondary.contrastText,
    },
    tipInstructionText: {
        color: themePrimary.palette.secondary.contrastText,
        marginBottom: ElementDimensions.margin10 + 'px',
    },
    tipLabel: {
        fontSize: '1.6em',
        color: themePrimary.palette.secondary.contrastText,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    tipText: {
        color: themePrimary.palette.secondary.contrastText,
        fontSize: '1.2rem',
    },
    totalLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    viewCheckButton: {
        textAlign: 'right',
    },
});

export type ManualTipButtonClickHandler = (event: React.MouseEvent<HTMLElement> | undefined, tipValue: number, isManual: boolean) => any;
export type ManualTipChangeHandler = (tipValue: number) => any;

export interface ManualTipSelectorProps {
    checkTotal: CheckTotal | null,
    onClickHandler: ManualTipButtonClickHandler,
    onManualTipHandler: ManualTipChangeHandler,
}

export default function ManualTipSelector(props: ManualTipSelectorProps) {
    const {checkTotal, onManualTipHandler, onClickHandler} = props;
    const isPortrait = true;
    const [tip, setTip] = React.useState<Tip | null>(null);
    const [manualTip, setManualTip] = React.useState<number>(0);
    const [manualTipString, setManualTipString] = React.useState<string>('');
    const [serviceChargeDialogOpen, setServiceChargeDialogOpen] = React.useState<boolean>(false);
    const [serviceCharge, setServiceCharge] = React.useState<string>('');
    const [showManualEntry, setShowManualEntry] = React.useState<boolean>(false);
    const [viewCheckDialogOpen, setViewCheckDialogOpen] = React.useState<boolean>(false);
    const [tipClickedAtLeastOnce, setTipClickedAtLeastOnce] = React.useState<boolean>(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    React.useEffect(() => {
        if (checkTotal !== null && checkTotal !== undefined) {
            setServiceCharge(checkTotal.minimum_tip.toString());

            if (!tipClickedAtLeastOnce) {
                if (checkTotal!!.tips[0].key === checkTotal!!.default_tip) {
                    handleTip1ButtonClick(undefined)
                }
                else if (checkTotal!!.tips[1].key === checkTotal!!.default_tip) {
                    handleTip2ButtonClick(undefined)
                }
                else if (checkTotal!!.tips[2].key === checkTotal!!.default_tip) {
                    handleTip3ButtonClick(undefined)
                }
            } 
        }
    }, []);

    const handleOkButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (validateTip()) {
            setTip(null);
            setShowManualEntry(false);
            onClickHandler(event, parseFloat((parseInt(manualTip.toString()) / 100).toString()), true);
        }
        else {
            setServiceChargeDialogOpen(true);
        }
    }

    const handleCancelButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setManualTipString('');
        setManualTip(0);
        setShowManualEntry(false);
    }

    const validateTip = () : Boolean => {
        if (manualTip < checkTotal!!.minimum_tip_amount) {            
            return false;
        }
        else {
            return true;
        }
    }

    const onManualEntryChange = (value: any, name?: any) => {
        if (value !== null && value !== undefined && value !== "") {
            var tipVal = parseFloat(value) * 100;

            if (tipVal >= 0) {
                setManualTip(parseFloat(value) * 100);
                onManualTipHandler(parseFloat((parseInt((parseFloat(value) * 100).toString()) / 100).toString()))
            }
            else {
                setManualTipString('');
            }
        }
        else {
            setTip(null);
            setManualTipString('')
            setManualTip(0)
            onManualTipHandler(0)
        }

        setManualTipString(value);
    }

    const okCancelButtonProps: OkCancelButtonsProps = {
        leftDisabled: false,
        rightDisabled: false,
        onLeftClickHandler: handleCancelButtonClick,
        onRightClickHandler: handleOkButtonClick,
    }    
    
    const formatTip = (value: string) => {
        let tipNumber = parseFloat(value);
        return new Intl.NumberFormat(checkOutState.state.restaurantLocale!!, { style: 'currency', 
            currency: GetCurrencyCode(checkOutState.state.restaurantLocale!!) }).format(tipNumber);
    }
    
    const handleServiceChargeDialogCloseClick = (event: React.MouseEvent<HTMLElement>) => {
        setServiceChargeDialogOpen(false);
    }

    const serviceChargeDialogProps: ServiceChargeDialogProps = {
        message: String_PayCheck_ServiceChargePopup(serviceCharge, checkTotal!!.minimum_tip_amount_string).find(s => s.key === userState.state.locale)!!.value,
        open: serviceChargeDialogOpen,
        onCloseHandler: handleServiceChargeDialogCloseClick,
    }

    const handleOtherButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setTip(null);
        onClickHandler(event, 0, false);
        setShowManualEntry(true);
    }

    const buttonProps: FullWidthButtonProps = {
        disabled: false,
        label: manualTip > 0 ? formatTip(parseFloat((manualTip *.01).toString()).toFixed(2)) : 
            String_Tip_ManualTipButton.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: manualTip > 0 ? false : true,
        size: FullWidthButtonSize.LargeNotRounded,
        onClickHandler: handleOtherButtonClick,
    }

    const handleTip1ButtonClick = (event: React.MouseEvent<HTMLElement> | undefined) => {
        setTipClickedAtLeastOnce(true)

        if (tip === checkTotal!!.tips[0]) {
            setTip(null);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, 0, false);
        }
        else {
            setTip(checkTotal!!.tips[0]);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, parseFloat(checkTotal!!.tips[0].value), false);
        }
    }

    const tipButton1Props: TipButtonProps = {
        selected:(tip === checkTotal!!.tips[0]) || (!tipClickedAtLeastOnce && (checkTotal!!.tips[0].key === checkTotal!!.default_tip)),
        amount: checkTotal!!.tips[0].value,
        percentage: checkTotal!!.tips[0].key,
        onClickHandler: handleTip1ButtonClick,
    }

    const handleTip2ButtonClick = (event: React.MouseEvent<HTMLElement> | undefined) => {
        setTipClickedAtLeastOnce(true)

        if (tip === checkTotal!!.tips[1]) {
            setTip(null);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, 0, false);
        }
        else {
            setTip(checkTotal!!.tips[1]);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, parseFloat(checkTotal!!.tips[1].value), false);
        }
    }

    const tipButton2Props: TipButtonProps = {
        selected: tip === checkTotal!!.tips[1] || (!tipClickedAtLeastOnce && (checkTotal!!.tips[1].key === checkTotal!!.default_tip)),
        amount: checkTotal!!.tips[1].value,
        percentage: checkTotal!!.tips[1].key,
        onClickHandler: handleTip2ButtonClick,
    }

    const handleTip3ButtonClick = (event: React.MouseEvent<HTMLElement> | undefined) => {
        setTipClickedAtLeastOnce(true)

        if (tip === checkTotal!!.tips[2]) {
            setTip(null);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, 0, false);
        }
        else {
            setTip(checkTotal!!.tips[2]);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, parseFloat(checkTotal!!.tips[2].value), false);
        }
    }

    const tipButton3Props: TipButtonProps = {
        selected: tip === checkTotal!!.tips[2] || (!tipClickedAtLeastOnce && (checkTotal!!.tips[2].key === checkTotal!!.default_tip)),
        amount: checkTotal!!.tips[2].value,
        percentage: checkTotal!!.tips[2].key,
        onClickHandler: handleTip3ButtonClick,
    }

    const handleCustomTipButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setTipClickedAtLeastOnce(true)

        if (tip === checkTotal!!.custom_tip) {
            setTip(null);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, 0, false);
        }
        else {
            setTip(checkTotal!!.custom_tip);
            setManualTipString('');
            setManualTip(0);
            onClickHandler(event, parseFloat(checkTotal!!.custom_tip.value), false);
        }
    }

    const customTipButtonProps: CustomTipButtonProps = {
        customText: checkTotal!!.show_custom_tip_button ? checkTotal!!.custom_tip_button_text : "",
        selected: checkTotal!!.show_custom_tip_button ? (tip === checkTotal!!.custom_tip) : false,
        amount: checkTotal!!.show_custom_tip_button ? checkTotal!!.custom_tip.value : "0",
        percentage: checkTotal!!.show_custom_tip_button ? checkTotal!!.custom_tip.key : 0,
        onClickHandler: handleCustomTipButtonClick,
    }

    const handleViewCheckButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setViewCheckDialogOpen(true);
    }

    const viewCheckButtonProps: MiniButtonProps = {
        value:'',
        disabled: false,
        label: String_System_View.find(s => s.key === userState.state.locale)!!.value,
        onClickHandler: handleViewCheckButtonClick,
    }

    const handleCancelManualButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setTip(null);
        setManualTipString('')
        setManualTip(0)
        onManualTipHandler(0)
        setShowManualEntry(false)
    }

    const cancelManualButtonProps: MiniButtonProps = {
        value:'',
        disabled: false,
        label: String_System_CancelButton.find(s => s.key === userState.state.locale)!!.value,
        onClickHandler: handleCancelManualButtonClick,
    }

    const handleViewCheckPayButtonClick = (event: React.MouseEvent<HTMLElement>, check: CheckSummary) => {
        
    }

    const handleViewCheckDialogCloseClick = (event: React.MouseEvent<HTMLElement>) => {
        setViewCheckDialogOpen(false);
    }

    const viewCheckDialogProps: ViewCheckDialogProps = {
        checkSummary: checkState.state.checkSummary,
        checkDetail: null,
        open: viewCheckDialogOpen,
        showFooter: false,
        useClaimedAmounts: true,
        onPayClickHandler: handleViewCheckPayButtonClick,
        onCloseHandler: handleViewCheckDialogCloseClick,
    }

    return (
        <div>
            <div className={classes.headerContainer}>
                <div className={isPortrait ? classes.headerGrid : classes.headerGridLandscape}>
                    <Typography variant="h6" className={classes.totalLabel}>
                        {String_Split_TotalLabel.find(s => s.key === userState.state.locale)!!.value} {checkState.state.checkSummary!!.total_with_service_charge_string}
                    </Typography>
                    <div className={classes.viewCheckButton}>
                        <MiniButton
                            value={checkState.state.checkSummary!!.id.toString()}
                            disabled={viewCheckButtonProps.disabled}
                            label={viewCheckButtonProps.label}
                            onClickHandler={viewCheckButtonProps.onClickHandler} />
                    </div>
                </div>
            </div>
            <div className={classes.tipContainer}>
                <div className={classes.tipInnerContainer}>
                    <Typography variant="h6" className={classes.tipInstructionText}>
                        {!showManualEntry && checkTotal && !checkTotal!!.has_auto_gratuity &&
                            <span>{String_Tip_SelectTipInstruction.find(s => s.key === userState.state.locale)!!.value}</span>
                        }
                        {!showManualEntry && !checkTotal &&
                            <span>{String_Tip_SelectTipInstruction.find(s => s.key === userState.state.locale)!!.value}</span>
                        }
                        {!showManualEntry && checkTotal && checkTotal!!.has_auto_gratuity &&
                            <span>{String_Tip_SelectAdditionalTipInstruction.find(s => s.key === userState.state.locale)!!.value}</span>
                        }
                        {showManualEntry &&
                            <span>{String_Tip_ManualTipInstruction.find(s => s.key === userState.state.locale)!!.value}</span>
                        }   
                    </Typography>
                    {!showManualEntry &&
                        <div className={classes.tipGridContainer}>
                            <div className={isPortrait === true ? classes.tipGrid : classes.tipGridLandscape}>
                                <TipButton 
                                    selected={tipButton1Props.selected}
                                    amount={tipButton1Props.amount}
                                    percentage={tipButton1Props.percentage}
                                    onClickHandler={tipButton1Props.onClickHandler} />
                                <TipButton 
                                    selected={tipButton2Props.selected}
                                    amount={tipButton2Props.amount}
                                    percentage={tipButton2Props.percentage}
                                    onClickHandler={tipButton2Props.onClickHandler}/>
                                <TipButton
                                    selected={tipButton3Props.selected}
                                    amount={tipButton3Props.amount}
                                    percentage={tipButton3Props.percentage}
                                    onClickHandler={tipButton3Props.onClickHandler}/>
                            </div>
                        </div>
                    }
                    
                    {showManualEntry &&
                        <div className={classes.manualTipContainer}>
                            <div className={classes.manualTipGrid}>
                                <div className={classes.tipLabel}>Tip: </div>
                                <CurrencyInput
                                    value={manualTipString}
                                    className={classes.tipInput}                                 
                                    intlConfig={{ locale: 'en-US', currency: 'USD' }}
                                    onValueChange={onManualEntryChange}
                                    allowNegativeValue={false} />
                                <div className={classes.manualTipCancelButton}>
                                    <MiniButton
                                        value={""}
                                        disabled={cancelManualButtonProps.disabled}
                                        label={cancelManualButtonProps.label}
                                        onClickHandler={cancelManualButtonProps.onClickHandler} />
                                </div>
                            </div>
                        </div>
                    }

                    <div className={classes.tipOkCancelButtonsContainer}>
                        {!showManualEntry &&
                            <FullWidthButton 
                                disabled={buttonProps.disabled}
                                label={buttonProps.label}
                                alternateColor={buttonProps.alternateColor}
                                size={buttonProps.size}
                                onClickHandler={buttonProps.onClickHandler}/>
                        }
                    </div>

                    {checkTotal !== null && checkTotal!!.show_custom_tip_button &&
                        <div className={classes.manualTipContainer}>
                            <CustomTipButton
                                customText={customTipButtonProps.customText}
                                selected={customTipButtonProps.selected}
                                amount={customTipButtonProps.amount}
                                percentage={customTipButtonProps.percentage}
                                onClickHandler={customTipButtonProps.onClickHandler}
                            />
                        </div>
                    }

                    
                </div>
            </div>

            <ViewCheckDialog 
                checkSummary={viewCheckDialogProps.checkSummary}
                checkDetail={viewCheckDialogProps.checkDetail}
                open={viewCheckDialogProps.open}
                showFooter={viewCheckDialogProps.showFooter}
                useClaimedAmounts={viewCheckDialogProps.useClaimedAmounts}
                onPayClickHandler={viewCheckDialogProps.onPayClickHandler}
                onCloseHandler={viewCheckDialogProps.onCloseHandler} />
        
            <ServiceChargeDialog 
                message={serviceChargeDialogProps.message}
                open={serviceChargeDialogProps.open}
                onCloseHandler={serviceChargeDialogProps.onCloseHandler} />
        </div>
    );
}